import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import DigitizeImg from "../../images/location_new/fold5/img01.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100" style={{ backgroundColor: "#1d8836" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Experience Next-Level Customization With Our Experienced App
              Developers in Atlanta
            </h2>
            <p>
              We serve our clients with pride as a reliable app development
              company in Atlanta. There are multiple projects that we are
              already involved in this region. If you haven’t digitized your
              business with a mobile app, we are here to serve you efficiently.
              Our team of expert Atlanta mobile app developers will enable you
              to grow your business digitally with its exceptional customization
              skills. Using our customized app solutions, you can ensure the
              sustainability of your business growth. We acquire the latest
              technologies with a solid development structure to provide you
              with an application that matches your critical business needs.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#1d8836",
                border: "1px solid #1d8836",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <LazyLoadImage
              src={DigitizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
